import api from './index'
import { axios } from '@/utils/request'

/**
 * login func
 * parameter: {
 *     username: '',
 *     password: '',
 *     remember_me: true,
 *     captcha: '12345'
 * }
 * @param parameter
 * @returns {*}
 */
export function login(parameter) {
  return axios({
    url: '/sys/login',
    method: 'post',
    data: parameter
  })
}

export function phoneLogin(parameter) {
  return axios({
    url: '/sys/phoneLogin',
    method: 'post',
    data: parameter
  })
}

export function mLogin(parameter) {
  return axios({
    url: '/sys/mLogin',
    method: 'post',
    data: parameter
  })
}

export function aggregateLogin(parameter) {
  return axios({
    url: '/sys/aggregateLogin',
    method: 'get',
    params: parameter
  })
}

export function getSmsCaptcha(parameter) {
  return axios({
    url: api.SendSms,
    method: 'post',
    data: parameter
  })
}

export function getInfo() {
  return axios({
    url: '/teaching/user/info',
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function logout(logoutToken) {
  return axios({
    url: '/sys/logout',
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'X-Access-Token':  logoutToken
    }
  })
}

/**
 * 微信登录二维码参数
 */
export function getQrcodeLoginParam(redirect){
  return axios({
      url: "/wechatAuth/getQrcodeLoginParam?redirectUrl=" + redirect,
      method: "get"
  })
}